

import React from "react";

interface ProgressBarProps {
  currentStep: number; // 1 or 2
}

const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep }) => {
  return (
    <div className="relative flex items-center w-full max-w-xs mx-auto ">
      {/* Full background line */}
      <div className="absolute top-1/2 left-0 w-full h-1 bg-gray-300 -translate-y-1/2 z-0 rounded-full" />

      {/* Progress line */}
      <div
        className="absolute top-1/2 left-0 h-1 bg-blue-600 -translate-y-1/2 z-10 rounded-full transition-all duration-300"
        style={{ width: currentStep === 1 ? "50%" : "100%" }}
      />


      {/* Step 1 circle */}
      <div className="z-20 w-6 h-6 rounded-full flex items-center justify-center bg-blue-600 text-white text-sm">
        1
      </div>

      {/* Center dot */}
      <div className="flex-1 flex justify-center z-20">
        <div className="w-3 h-3 bg-blue-600 rounded-full" />
      </div>

      {/* Step 2 circle */}
      <div
        className={`z-20 w-6 h-6 rounded-full flex items-center justify-center text-sm ${currentStep === 2 ? "bg-blue-600 text-white" : "bg-gray-300 text-gray-600"
          }`}
      >
        2
      </div>
    </div>
  );
};

export default ProgressBar;



